<app-top-nav-registration></app-top-nav-registration>
<div class="h-30"></div>
<div class="container">
  <div class="content">
    <div class="facility-heading">
      {{ 'sgpRegTitle' | translate:translations }}
    </div>
    <div class="designatedFacilityForm" >
      <form [hidden]="!hideEmailSentSpan">
        <h5><strong>{{ 'sgpRegInstructions' | translate:translations }}</strong></h5>
        <span class="already-registered">{{ 'sgpRegAlreadyRegistered' | translate:translations }} <a href="/bb-login">{{ 'sgpRegSignIn' | translate:translations }}</a></span>
        <div class="h-30"></div>

        <div class="form-fields">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>{{ 'sgpRegEmailLabel' | translate:translations }}</mat-label>
            <input matInput class="form-control-textbox" name="email" [(ngModel)]="BBsgpinvitation.email" />
          </mat-form-field>
          @if (isSubmitted && !this.isInputValid.email) {
            <mat-error class="registration-validation-error" >{{ 'sgpRegEmailRequired' | translate:translations }}</mat-error>
          }
        </div>
        <div class="mb-10"></div>
        <div class="form-fields">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>{{ 'sgpRegProvinceLabel' | translate:translations }}</mat-label>
            <mat-select [placeholder]="'sgpRegProvincePlaceholder' | translate:translations" name="province" [(ngModel)]="BBsgpinvitation.provinceId">
              @for (mt of provinces; track mt) {
                <mat-option [value]="mt.id">{{
                mt.provinceName}}</mat-option>
              }
            </mat-select>
            <mat-hint>{{ 'sgpRegProvinceHint' | translate:translations }}</mat-hint>
          </mat-form-field>
          @if (isSubmitted && !this.isInputValid.province) {
            <mat-error class="registration-validation-error" >{{ 'sgpRegProvinceRequired' | translate:translations }}</mat-error>
          }
        </div>
        <div class="h-30"></div>
        <div class="form-buttons">
          <button class="submit-form-button" (click)="register()">{{ 'sgpRegSubmit' | translate:translations }}</button>
        </div>
      </form>
      <span [hidden]="hideEmailSentSpan">
        <h3>{{ 'sgpRegCheckEmailHeading' | translate:translations }}</h3>
        <strong>{{ 'sgpRegCheckEmailBody' | translate:translations }}</strong>
      </span>
    </div>
  </div>
</div>
<app-footer></app-footer>
